module.exports = __webpack_public_path__ + "static/media/adventurer.d52df586.png";